let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9y9OJ")).then(() => parcelRequire('coREq'));